import * as React from "react";
import { Button } from "@blueprintjs/core";
import { StoresContext } from "../../pages/_app";
import { useContext } from "react";
import { DownloadData, DownloadKind } from "../../stores/genome-store";

interface BedDownloadButtonProps {
  methylationUuid: string;
  name: string;
  genomeUuid: string;
}

const BedDownloadButton = (props: BedDownloadButtonProps) => {
  const rootStore = useContext(StoresContext);

  const onClick = () => {
    const data: DownloadData = {
      kind: DownloadKind.Methylation,
      genomeName: props.name,
      genomeUuid: props.genomeUuid,
      methylationUuid: props.methylationUuid,
      context: "Genome Overview Tab",
    };
    rootStore.userStore.tryToDoGuardedAction(() => {
      return rootStore.genomeStore.downloadFile(data);
    });
  };

  return (
    <Button
      className="atcc--light-gradient atcc--uppercase"
      onClick={onClick}
      large={true}
      text="Download Methylation"
    />
  );
};

export default BedDownloadButton;
